import React from "react";
import CarouselBanners from "components/molecules/CarouselBanners";
import { useLoaderStore } from "stores/loader";
import useBannersData from "queries/useBannersData";
import { useSettingsStore } from "stores/settings";

const CarouselBannersContainer = React.memo(() => {
  const { bannersData } = useBannersData();
  const currentLanguage = useSettingsStore((state) => state.language);
  const { overlayLoading } = useLoaderStore();

  if (!bannersData) {
    return null;
  }

  return (
    <CarouselBanners
      language={currentLanguage}
      slides={bannersData}
      isLoading={overlayLoading}
    />
  );
});

export default CarouselBannersContainer;
